import type { RootState } from '~/redux/store';
import type { EmailTemplate } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export const getParams = (state: RootState): IRestIndexParams<EmailTemplate> => ({
  sortBy: state.emailTemplates.sortBy,
  page: state.emailTemplates.page,
  pageSize: state.emailTemplates.pageSize,
  with: state.emailTemplates.with.join(','),
  ...state.emailTemplates.filters,
});

export const getItem = (state: RootState): EmailTemplate | null => state.emailTemplates.item;

export const getInitialItem = (state: RootState): string | null => state.emailTemplates.initialItem;
